define('modules/accounts/users/model',['require','exports','module','app','env','base/model'],function (require, exports, module) {
  "use strict";

  var app = require("app");
  var Config = require("env");
  var BaseModel = require("base/model");

  var model = BaseModel.extend({
    initialize: function () {
      this.initRequestEvents();
    },
    defaults: {
      lang: "es",
      role: "cpm_mdirector",
    },
    urlRoot: function () {
      return Config.backendUrl + "/accounts/users";
    },
  });

  module.exports = model;
});

